import React from 'react';
import PropTypes from 'prop-types';
import AssetForm from '../Asset/AssetForm.react';
import VenueActions from '../../actions/VenueActionCreator';

const VenueAssetForm = React.createClass({

    render: function() {
        const returnUrl = (this.props.returnUrl ? this.props.returnUrl : '/dashboard/venue/' + this.props.routeParams.venueId + '/edit');
        
        return (
            <AssetForm title="New Asset" 
                returnUrl={returnUrl}
                onSubmit={this.onSubmitForm}
            />
        )
    },
    onSubmitForm: function(asset) {
        return VenueActions.saveAsset(this.props.routeParams.venueId, asset);
    }
});

VenueAssetForm.propTypes = {
    returnUrl: PropTypes.string,
};

export default VenueAssetForm;
